<template>
<div class="block-details-wrap">
  <!--
  <div class="block-tips flex-row">
    <el-tag type="danger">审核不通过</el-tag>
    <span>退回原因：1.地址需详细到号活接到号地块拉收到啦都流口水阿卡丽等加拉手 </span>
  </div>
  -->
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="门店账号信息" name="1">
      <div class="block-account-info-wrap">
        <h3>门店账号信息</h3>
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="管理员账号：">
            <el-input v-model="form.userAccount" class="block-width" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="门店编号：">
            <el-input v-model="form.shopId" class="block-width" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="注册手机：">
            <el-input v-model="form.phone" class="block-width" :disabled="true"></el-input>
            <el-button type="primary" class="block-btn" @click="changePhoneShow = true">更换</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="block-info-wrap">
        <h3>门店基础信息</h3>
        <el-form ref="form" :model="form" label-width="150px">
          <el-form-item label="门店名称：">
            <div class="block-item flex-row">
              <el-input v-model="form.shopName" class="block-width"></el-input>
              <span>如：老台山（科兴店）</span>
            </div>
          </el-form-item>
          <el-form-item label="姓名（管理员）">
            <div class="block-item flex-row">
              <el-input v-model="form.userName" class="block-width" :disabled="true"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="所属品牌：">
            <el-select v-model="form.brandId" placeholder="请选择" class="search-input">
              <el-option
                v-for="item in brandVOList"
                :key="item.brandId"
                :label="item.brandName"
                :value="item.brandId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="门店类型：">
            <el-radio v-model="form.shopType" :label="1" :disabled="true">直营</el-radio>
            <el-radio v-model="form.shopType" :label="2" :disabled="true">加盟</el-radio>
            <el-radio v-model="form.shopType" :label="3" :disabled="true">联营</el-radio>
          </el-form-item>
          <el-form-item label="合伙人（加盟商）：" v-if="Number(form.shopType) !== 1">
            <el-select v-model="form.partnerAccount" placeholder="请选择" class="search-input">
              <el-option
                v-for="item in partnerList"
                :key="item.partnerAccount"
                :label="item.partnerName"
                :value="item.partnerAccount">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属区域：">
            <el-select v-model="form.zoneId" placeholder="请选择" class="search-input">
              <el-option
                v-for="item in areaList"
                :key="item.zoneId"
                :label="item.zoneName"
                :value="item.zoneId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经营地址：">
            <div class="block-column">
              <div class="block-row">
                <el-cascader size="large" :options="options" v-model="selectedOptions" @change="handleChange"></el-cascader>
              </div>
              <el-input type="textarea" class="block-textarea" v-model="form.shopAddress"></el-input>
            </div>
          </el-form-item>
        </el-form>
        <div class="block-footer-wrap">
          <el-button type="primary" @click="hanlderSave(1)">保存</el-button>
          <el-button type="primary" @click="hanlderSave(2)">保存，下一步</el-button>
        </div>
      </div>
    </el-tab-pane>
    <el-tab-pane label="支付收款账号" name="2">
      <div class="block-pay-wrap flex-row">
        <div class="block-left">
          <span class="block-title">当前关联支付收款账号</span>
          <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="收款编号：">
              <el-input v-model="form.merchantId" class="block-width" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="账号：">
              <el-input v-model="form.merchantAccount" class="block-width" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="结算类型：">
              <span>{{SETTLE_TYPE[form.settleType]}}</span>
            </el-form-item>
            <el-form-item label="结算对象：">
              <span>{{SETTLE_TO_TYPE[form.settleTo]}}</span>
            </el-form-item>
            <el-form-item label="收款人：">
              <span>{{form.bankAccountName}}</span>
            </el-form-item>
            <el-form-item label="收款卡：">
              <span>{{form.bankCardNo}}</span>
            </el-form-item>
            <el-form-item label="收款银行：">
              <span>{{form.bankName}}</span>
            </el-form-item>
          </el-form>
        </div>
        <div class="block-right" v-if="!showUpdateAccount">
          <span class="block-title">变更后收款账号</span>
          <el-form ref="form" :model="form" label-width="100px">
            <el-form-item label="收款编号：">
              <el-input v-model="updateForm.newMerchantId" class="block-width"></el-input>
            </el-form-item>
            <el-form-item label="手机号：">
              <el-input v-model="updateForm.phone" class="block-width"></el-input>
            </el-form-item>
            <div class="block-row-item flex-row">
              <el-input v-model="updateForm.picCode" class="block-width"></el-input>
              <img :src="smsImgCode" alt="" class="codeImg"/>
            </div>
            <div class="block-row-item flex-row block-mergin">
              <el-input v-model="updateForm.smsCode" class="block-width"></el-input>
              <el-button type="primary" class="block-btn" v-if="timeShow1">{{time1}}s后重新获取验证码</el-button>
              <el-button type="primary" class="block-btn" v-else @click="getSmsCode(updateForm.phone,1,'time1','timeShow1')">获取手机验证码</el-button>
            </div>
            <p class="block-msg-tips">变更收款账号后，请重新登录app账号生效</p>
          </el-form>
        </div>
      </div>

      <el-button type="primary" v-if="showUpdateAccount" @click="dialogVisible = true">变更收款账号</el-button>
      <el-button type="primary" v-else @click="updateMerchantId">确定关联</el-button>
    </el-tab-pane>
  </el-tabs>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="30%">
    <div class="block-dialog-wrap flex-column">
      <span>变更收款编号，需要先将当前绑定的收款编号进行解绑</span>
      <div class="block-content block-row">
        <el-input v-model="smsCode" class="block-input"></el-input>
        <el-button type="primary" class="block-btn" v-if="timeShow2">{{time2}}s后重新获取验证码</el-button>
        <el-button type="primary" class="block-btn" v-else @click="getSmsCode(form.phone,2,'time2','timeShow2')">验证码</el-button>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="unboundMerchantId">确定解绑</el-button>
    </span>
  </el-dialog>
  <el-dialog
    :visible.sync="changePhoneShow"
    width="30%"
    :close-on-click-modal="false">
    <el-form :label-position="labelPosition" label-width="120px">
      <el-form-item label="当前绑定手机号">
        <el-input v-model="changePhoneForm.oldPhone" class="block-width" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="短信验证码">
        <el-input v-model="changePhoneForm.oldSmsCode" class="block-width"></el-input>
        <el-button type="primary" class="block-btn" v-if="timeShow3">{{time3}}s后重新获取验证码</el-button>
        <el-button type="primary" class="block-btn" @click="getSmsCode(changePhoneForm.oldPhone,3,'time3','timeShow3')" v-else>获取验证码</el-button>
      </el-form-item>
      <el-form-item label="新的绑定手机">
        <el-input v-model="changePhoneForm.newPhone" class="block-width"></el-input>
      </el-form-item>
      <el-form-item label="短信验证码">
        <el-input v-model="changePhoneForm.newSmsCode" class="block-width"></el-input>
        <el-button type="primary" class="block-btn" v-if="timeShow4">{{time4}}s后重新获取验证码</el-button>
        <el-button type="primary" class="block-btn" @click="getSmsCode(changePhoneForm.newPhone,3,'time4','timeShow4')" v-else>获取验证码</el-button>
      </el-form-item>
    </el-form>
    <div class="block-footer flex-row-center">
      <el-button type="primary" @click="updatePhone">确认</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { editShop, getShopInfo, updateMerchantId, getZoneInfo, getPicCode, getSmsCode, unboundMerchantId, updatePhone, getPartnerInfo } from '@/api/merchant-info'
import { regionData, CodeToText } from 'element-china-area-data'
import { SETTLE_TYPE, SETTLE_TO_TYPE } from '../ENUM'
export default {
  data () {
    return {
      changePhoneForm: {
        oldPhone: '',
        oldSmsCode: '',
        newPhone: '',
        newSmsCode: ''
      },
      time1: 60,
      time2: 60,
      time3: 60,
      time4: 60,
      timeShow1: false,
      timeShow2: false,
      timeShow3: false,
      timeShow4: false,
      changePhoneShow: false,
      dialogVisible: false,
      smsCode: '',
      smsImgCode: '',
      SETTLE_TYPE,
      SETTLE_TO_TYPE,
      options: regionData,
      selectedOptions: [],
      showUpdateAccount: true,
      brandVOList: [],
      activeName: '1',
      form: {
        brandId: '',
        userAccount: '',
        userName: '',
        shopId: '',
        shopName: '',
        phone: '',
        partnerAccount: '',
        partnerName: '',
        zoneId: '',
        shopAddress: '',
        shopType: '',
        shopProvinceName: '',
        shopCityName: '',
        shopAreaName: '',
        shopArea: '',
        shopProvince: '',
        shopCity: ''
      },
      updateForm: {
        newMerchantId: '',
        phone: '',
        smsCode: '',
        picCode: ''
      },
      areaList: [],
      partnerList: [],
      aresAddress: ''
    }
  },
  async created () {
    try {
      await this.getShopInfo()
      this.getZoneInfo()
      this.getPicCode()
      this.getPartnerInfo()
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    // 加盟商列表
    async getPartnerInfo () {
      try {
        const res = await getPartnerInfo({
          shopId: this.form.shopId
        })
        if (res.error_code === '0') {
          this.partnerList = res.data
        } else {
          this.$message.error(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      }
    },
    async updatePhone () {
      try {
        const res = await updatePhone({
          ...this.changePhoneForm,
          shopId: this.form.shopId
        })
        if (res.error_code === '0') {
          this.changePhoneShow = false
        } else {
          this.$message.warning(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 解绑
    async unboundMerchantId () {
      try {
        const res = await unboundMerchantId({
          shopId: this.form.shopId,
          merchantId: this.form.merchantId,
          phone: this.form.phone,
          smsCode: this.smsCode
        })
        if (res.error_code === '0') {
          this.dialogVisible = false
          this.showUpdateAccount = false
          this.$message.success('解绑成功')
        } else {
          this.$message.error(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 获取图形验证码
    async getPicCode () {
      try {
        const res = await getPicCode()
        this.smsImgCode = res.data
      } catch (e) {
        console.log(e)
      }
    },
    hanlderSave (type) {
      this.editShop(type)
    },
    // 设置地区
    handleChange (value) {
      this.form.shopProvince = value[0]
      this.form.shopCity = value[1]
      this.form.shopArea = value[2]
      this.form.shopProvinceName = CodeToText(value[0])
      this.form.shopCityName = CodeToText(value[1])
      this.form.shopAreaName = CodeToText(value[2])
    },
    setTimeOut (time, show) {
      if (!time && !show) return
      this[show] = true
      const timeOut3 = setInterval(() => {
        if (this[time] > 0) {
          this[time]--
        } else {
          this[show] = false
          clearInterval(timeOut3)
        }
      }, 1000)
    },
    // 获取手机号码
    async getSmsCode (phone, businessType, time, show) {
      try {
        const res = await getSmsCode({
          phone: phone,
          businessType: businessType
        })
        if (res.error_code === '0') {
          this.setTimeOut(time, show)
          this.$message.success('短信已发送成功，请注意查收')
          if (businessType === 3) {
            this.getShopInfo()
          }
        } else {
          this.$message.warning(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 获取所属区域
    async getZoneInfo () {
      try {
        const res = await getZoneInfo({
          shopId: this.$route.query.shopId
        })
        if (res.error_code === '0') {
          this.areaList = res.data
        } else {
          this.$message.error(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 变更收款账号
    async updateMerchantId () {
      try {
        await this.$confirm('确认关联吗？')
        const res = await updateMerchantId({
          shopId: this.form.shopId,
          oldMerchantId: this.form.merchantId,
          ...this.updateForm
        })
        if (res.error_code === '0') {
          this.$message.success('关联成功')
        } else {
          this.$message.error(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 获取门店信息
    async getShopInfo () {
      try {
        const res = await getShopInfo({ shopId: this.$route.query.shopId })
        if (res.error_code === '0') {
          this.form = res.data
          this.selectedOptions = [this.form.shopProvince + '', this.form.shopCity + '', '' + this.form.shopArea]
          this.changePhoneForm.oldPhone = this.form.phone
          this.brandVOList = this.form.brandVOList
          this.form.brandId = this.form.brandId === 0 ? '' : this.form.brandId
        } else {
          this.$message.error(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      }
    },
    async editShop (type) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let res
      try {
        const params = { ...this.form }
        res = await editShop({
          ...params
        })
        if (type === 2) {
          this.activeName = '2'
        }
        if (res.error_code === '0') {
          this.$message.success('编辑成功')
          this.getShopInfo()
        } else {
          this.$message.error(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      } finally {
        loading.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.block-details-wrap{
  margin:20px 20px 20px 0;
  background:#fff;
  padding:20px;
}
h3{
  padding:20px 0 30px 0;
}
.block-tips {
  align-items:center;
  span{
    display:inline-block;
    margin:0 0 0 20px;
  }
}
.block-width{
  width:240px;
}
.block-textarea{
  margin:15px 0 0 0;
  width:440px;
}
.search-select{
  width:120px;
  margin:0 0 0 20px;
}
.search-select:first-child{
  margin:0;
}
.block-right{
  margin:0 0 0 40px;
}
.block-title{
  display:inline-block;
  padding:20px 0 30px 0;
}
.block-btn{
  margin:0 0 0 20px;
}
.block-row-item{

}
.block-mergin{
  margin:20px 0;
}
.block-footer-wrap{
  padding:50px 0;
}
.codeImg{
  height:40px;
  margin:0 0 0 20px;
}
.block-content{
  margin:20px 0 0 0;
  .block-input{
    width:240px;
  }
}
.block-msg-tips{
  margin:80px 0 0 0;
  // color:#e6a23c;
  font-weight:bolder;
}
</style>
